/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Automix_Knee_LabelInputs */



/**
* | output |
* | --- |
* | "Knee" |
*
* @param {Audio_Description_Export_Automix_Knee_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_automix_knee_label = /** @type {((inputs?: Audio_Description_Export_Automix_Knee_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Automix_Knee_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Genou")
	if (locale === "de") return /** @type {LocalizedString} */ ("Knie")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ginocchio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Колено")
	if (locale === "es") return /** @type {LocalizedString} */ ("Rodilla")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("膝盖")
	if (locale === "ja") return /** @type {LocalizedString} */ ("膝")
	if (locale === "hi") return /** @type {LocalizedString} */ ("घुटना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Joelho")
	return /** @type {LocalizedString} */ ("Knee")
});